// extracted by mini-css-extract-plugin
module.exports = {"strategy":"Strategy_strategy__3IEin","section":"Strategy_section__1kFyt","box":"Strategy_box__1xPFy"};